import { ModelBase } from '../abstract/model-base.model';
import { Address } from '../address/address.model';
import { Partner } from './partner.model';
import { FkField, OmitField } from 'src/app/@shared/decorators/api-field.decorator';

export class Establishment extends ModelBase {

    static override CLASS_NAME: string = 'Establishment';

    private _partner!: Partner;
    private _name!: string;
    private _address!: Address;
    private _identifier!: string;
    private _isHeadquarters!: boolean;

    public override toString(): string {
        return this._name;
    }

    public get address(): Address {
        return this._address;
    }

    public set address(value: any) {
        this._setValue('_address', value, 'Address');
    }

    public get identifier(): string {
        return this._identifier;
    }

    public set identifier(value: any) {
        this._setValue('_identifier', value, 'string');
    }

    @OmitField()
    public get isHeadquarters(): boolean {
        return this._isHeadquarters;
    }

    public set isHeadquarters(value: any) {
        this._setValue('_isHeadquarters', value, 'boolean');
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: any) {
        this._setValue('_name', value, 'string');
    }

    @FkField()
    public get partner(): Partner {
        return this._partner;
    }

    public set partner(value: any) {
        // Le serveur sert le partenaire par son seul identifiant : on le garde, pour
        // retrouver la fiche de l'établissement (Consulter de l'assistant, #1217).
        this._setValue('_partner', typeof value === 'number' ? { id: value } : value, 'Partner');
    }

}
